import { CourseData } from "@vixi/types";
import { genArray } from "@/arrays/genArray";
import { STEP_TYPE } from "@vixi/types";
import { LangKey } from "@vixi/localization";

export const emptyConversation = (id: number): CourseData.ConversationStep => ({
  id,
  order: 0,
  type: STEP_TYPE.CONVERSATION,
  messages: [
    {
      order: 0,
      authorMessage: "Conversation.YourPlaceholder",
      learnerMessage: "Conversation.VixiPlaceholder",
    },
  ],
});

export const emptyMcq = (id: number): CourseData.McqStep => ({
  id,
  order: 0,
  type: STEP_TYPE.MCQ,
  multipleChoice: {
    question: "Question.Placeholder.Question",
    options: genArray(() => "Question.Placeholder.Option" satisfies LangKey, 3),
    correctAnswer: 0,
  },
});

export const emptyFitb = (id: number): CourseData.FitbStep => ({
  id,
  order: 0,
  type: STEP_TYPE.FITB,
  fillInTheBlank: {
    question: "Question.Placeholder.Question",
    options: genArray(() => "Question.Placeholder.Option" satisfies LangKey, 3),
    correctAnswer: 0,
  },
});

export const emptyMatching = (id: number): CourseData.MatchingStep => ({
  id,
  order: 0,
  type: STEP_TYPE.MATCHING,
  matching: {
    question: "Question.Placeholder.Question",
    answers: genArray(
      () => ({
        question: "Question.Placeholder.Option" satisfies LangKey,
        answer: "Question.Placeholder.Option" satisfies LangKey,
      }),
      3,
    ),
  },
});

export const emptyStep = (type: STEP_TYPE, id: number): CourseData.Step => {
  return {
    [STEP_TYPE.CONVERSATION]: emptyConversation,
    [STEP_TYPE.MCQ]: emptyMcq,
    [STEP_TYPE.FITB]: emptyFitb,
    [STEP_TYPE.MATCHING]: emptyMatching,
  }[type](id);
};

export const emptyLesson = (id: number): CourseData.Lesson => ({
  id,
  order: 0,
  selectedTitle: 0,
  titles: genArray(() => "Title" satisfies LangKey, 6),
  steps: [emptyConversation(0)],
});

export const emptyUnit = (id: number): CourseData.Unit => ({
  id,
  order: 0,
  title: "Unit title",
  lessons: [emptyLesson(0)],
});
